/**
 * @format
 */
import {
  ADD_LIST_VIEWER_REQUEST,
  ADD_LIST_VIEWER_SUCCESS,
  ADD_LIST_VIEWER_FAILURE,
} from '../actions';
import request from '../../../helpers/request';
import { enqueueNotification } from '../../app';

export default (
  workspace_id,
  listId,
  viewerIds = [],
  willCallReload = false
) => {
  return async dispatch => {
    dispatch({
      type: ADD_LIST_VIEWER_REQUEST,
      payload: {
        viewerIds: viewerIds === 'all' ? [] : viewerIds,
        willCallReload,
      },
    });

    try {
      const { data } = await request.post(
        `/api/pipeline/lists/v1/${workspace_id}/${listId}/share/add`,
        {
          members: viewerIds,
        },
        dispatch
      );

      if (data.success) {
        localStorage.setItem(
          'listViewersLength',
          data.data === 'all' ? 1 : data.data.length
        );
        dispatch({
          type: ADD_LIST_VIEWER_SUCCESS,
          payload: {
            listId,
            data: data.data,
            viewerIds: viewerIds === 'all' ? [] : viewerIds, // Ensure viewerIds is an array
          },
        });
        dispatch(enqueueNotification('List shared with selected members'));
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: ADD_LIST_VIEWER_FAILURE,
          payload: { message, viewerIds },
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while adding list viewer, please try again.';
      dispatch({
        type: ADD_LIST_VIEWER_FAILURE,
        payload: { message, viewerIds: viewerIds === 'all' ? [] : viewerIds },
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};
